export class NamThang {
    Name?: string;
    ID?: number;    
}

